import { Component, OnInit, OnDestroy, HostListener } from "@angular/core";
import { LoginService } from "../login.service";
import { ActivatedRoute } from "@angular/router";
import { Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";

@Component({
    selector: "app-bottombar",
    templateUrl: "./bottombar.component.html",
    styleUrls: ["./bottombar.component.scss"],
    standalone: false
})
export class BottombarComponent implements OnInit, OnDestroy {
  showSearchPopup = false;
  showButton = false;
  currentDate = new Date();
  currentYear = this.currentDate.getFullYear();
  currentRoute = "";

  private isFooterVisible = false;
  private hideTimeout: ReturnType<typeof setTimeout> | null = null;
  private readonly HOVER_THRESHOLD = 60;

  constructor(
    public loginService: LoginService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private http: HttpClient
  ) {}

  ngOnInit() {
    this.currentRoute = this.activatedRoute.snapshot.routeConfig.path;
  }

  ngOnDestroy() {
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
    }
    document.body.classList.remove('footer-open');
  }

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {
    const nearBottom = event.clientY > window.innerHeight - this.HOVER_THRESHOLD;
    if (nearBottom) {
      this.showFooter();
    } else {
      this.scheduleHide();
    }
  }

  private showFooter() {
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
      this.hideTimeout = null;
    }
    if (!this.isFooterVisible) {
      this.isFooterVisible = true;
      document.body.classList.add('footer-open');
    }
  }

  private scheduleHide() {
    if (this.hideTimeout !== null || !this.isFooterVisible) {
      return;
    }
    this.hideTimeout = setTimeout(() => {
      this.isFooterVisible = false;
      document.body.classList.remove('footer-open');
      this.hideTimeout = null;
    }, 400);
  }

  goAppointments() {
    this.router.navigate(["/appointments"]);
  }

  goBilling() {
    this.router.navigate(["/billing"]);
  }

  goTrainingHub() {
    this.router.navigate(["/training-hub"]);
  }

  goMedical() {
    const type = this.loginService.isCardio
      ? "cardio"
      : this.loginService.isGastro
      ? "gastro"
      : this.loginService.isEyes
      ? "eyes"
      : "aweb";
    this.http.post("/api/administration", { type }).subscribe((data: string) => {
      window.location.href = data;
    });
  }
}
